import { PageLayout } from "@primer/react";
import { useAppSelector } from "../hooks/useAppSelector";
import { eNavSubMode } from "../model/common/eNavSubMode";
import AppList from "./AppList";
import Humberger from "./Humberger";
import Menu from "./Menu";
import Header from "./Header";
import Footer from "./Footer";
import HeaderDefault from "./HeaderDefault";
import { useWindowSize } from "../hooks/useWindowSize";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { appConst } from "../AppConst";
import { getSidebarThemeVars } from "./sidebarThemeVars";

interface ILayoutProps {
  children?: React.ReactNode;
}


const Layout = (props: ILayoutProps) => {
  const { navSubMode } = useAppSelector((x) => x.common.layout);
  const sidebarAppBg = process.env.REACT_APP_SIDEBAR_APP_BG;
  const sidebarMenuBg = process.env.REACT_APP_SIDEBAR_MENU_BG;
  // const layoutBackground =
  // process.env.REACT_APP_LAYOUT_BG ||
  // "linear-gradient(to bottom, rgba(0, 123, 122, 0.9), rgba(245, 231, 161, 0.9))";
  const layoutBackground =
    process.env.REACT_APP_LAYOUT_BG ||
    "linear-gradient(to bottom, rgba(0, 123, 122, 0.9), rgba(245, 231, 161, 0.9))";
  const sidebarTheme = getSidebarThemeVars();
  return (
    <>
      <div
        style={{
          position: "relative",
          background: `
            ${layoutBackground},
            url(${appConst.appURLLogo})
          `,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
           minHeight: window.innerHeight, 
        }}
      >
        {/*        background: `
          linear-gradient(
    to bottom,
    rgba(66, 165, 245, 0.85),
    rgba(21, 101, 192, 0.9)
  ), */}
  {/* , */}
        <Header/>
        <div
          style={{
            display: "flex",
            // minHeight: window.innerHeight,
            backdropFilter: "blur(2rem)",
            ...sidebarTheme,
          }}
        >
          <div
            style={{
              width: "80px",
              display: "flex",
              flexDirection: "column",
               // backgroundColor: "rgba(255,255,255,1)",
              backgroundColor: sidebarAppBg || undefined,
              position: "relative",
            }}
          >
            <div>
              <Humberger />
            </div>
            <div>
              <AppList />
            </div>
            {/* <div
              style={{
                position: "absolute",
                bottom: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: 2,
              }}
            >
              <UserPanel />
            </div> */}
          </div>

          {navSubMode === eNavSubMode.FULL && (
            <div
              style={{
                width: "205px",
                display: "flex",
                flexDirection: "column",
                backgroundColor: sidebarMenuBg || "rgba(255,255,255,0.4)",
                position: "relative",
              }}
            >
              {/* <div
                id="brand"
                style={{
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <BrandLogo />
              </div> */}
              <div style={{ paddingLeft: 0, paddingRight: 0, flex: 1,
                        overflowY: "auto",
                        minHeight: "calc(100vh - 80px)",
                        maxHeight: "calc(100vh - 80px)" }}>
                <Menu />
              </div>
            </div>
          )}

          <div
            style={{
              overflow: "auto",
              flex: 1,
              backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >


              
              <PageLayout padding="none" containerWidth="full">
                <PageLayout.Content>
                   {/* <HeaderDefault /> */}
                     {/* <Header/> */}
                  <div style={{ width: "100%" }}>         
                    {props.children}
                  </div>
                </PageLayout.Content>
              </PageLayout>
        </div>
          {/* <div>
            <Footer />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Layout;
